import React from "react";
import {
  CheckCircle, Trash2, ShieldCheck, FileDown, Download, X, Loader2,
} from "lucide-react";
import { Button } from "../ui/button";

export function BatchActionToolbar({
  selectedCount, draftSelectedCount, finalizedSelectedCount,
  busyAction, batchProgress,
  canScreen, canMutate,
  onRunScreening, onDownloadPdfs, onExportCsv, onDeleteBatch, onClear,
}) {
  if (selectedCount === 0) return null;

  return (
    <div
      data-testid="batch-action-toolbar"
      className="mb-4 flex flex-wrap items-center gap-3 p-3 bg-teal-500/5 border border-teal-500/20 rounded-lg"
    >
      <div className="flex items-center gap-2 text-sm text-teal-300">
        <CheckCircle size={16} />
        <span data-testid="selection-count">
          {selectedCount} seleccionado{selectedCount !== 1 ? "s" : ""}
          {draftSelectedCount > 0 && finalizedSelectedCount > 0 && (
            <span className="ml-1 text-xs text-slate-400">
              ({finalizedSelectedCount} activo{finalizedSelectedCount !== 1 ? "s" : ""}, {draftSelectedCount} borrador{draftSelectedCount !== 1 ? "es" : ""})
            </span>
          )}
          {draftSelectedCount > 0 && finalizedSelectedCount === 0 && (
            <span className="ml-1 text-xs text-slate-400">
              (solo borradores)
            </span>
          )}
        </span>
      </div>
      <div className="flex flex-wrap gap-2 ml-auto">
        {canScreen && (
          <Button
            size="sm"
            variant="outline"
            disabled={!!busyAction || finalizedSelectedCount === 0}
            title={finalizedSelectedCount === 0
              ? "El screening no aplica a borradores; selecciona al menos un cliente activo"
              : draftSelectedCount > 0
                ? `Solo se procesarán los ${finalizedSelectedCount} clientes activos (los ${draftSelectedCount} borradores se ignoran)`
                : undefined}
            onClick={onRunScreening}
            data-testid="batch-screening-btn"
            className="bg-slate-900 border-slate-700 text-slate-200 hover:bg-slate-800 disabled:opacity-50"
          >
            {busyAction === "screening"
              ? <Loader2 size={14} className="mr-2 animate-spin" />
              : <ShieldCheck size={14} className="mr-2" />}
            Correr screening
          </Button>
        )}
        <Button
          size="sm"
          variant="outline"
          disabled={!!busyAction || finalizedSelectedCount === 0}
          title={finalizedSelectedCount === 0
            ? "Solo se generan PDFs de clientes activos"
            : draftSelectedCount > 0
              ? `Solo se procesarán los ${finalizedSelectedCount} clientes activos`
              : undefined}
          onClick={onDownloadPdfs}
          data-testid="batch-pdfs-btn"
          className="bg-slate-900 border-slate-700 text-slate-200 hover:bg-slate-800 disabled:opacity-50"
        >
          {busyAction === "pdfs"
            ? <Loader2 size={14} className="mr-2 animate-spin" />
            : <FileDown size={14} className="mr-2" />}
          Generar PDFs
        </Button>
        <Button
          size="sm"
          variant="outline"
          disabled={!!busyAction || finalizedSelectedCount === 0}
          title={finalizedSelectedCount === 0
            ? "Solo se exportan clientes activos"
            : draftSelectedCount > 0
              ? `Solo se exportarán los ${finalizedSelectedCount} clientes activos`
              : undefined}
          onClick={onExportCsv}
          data-testid="batch-export-btn"
          className="bg-slate-900 border-slate-700 text-slate-200 hover:bg-slate-800 disabled:opacity-50"
        >
          {busyAction === "export"
            ? <Loader2 size={14} className="mr-2 animate-spin" />
            : <Download size={14} className="mr-2" />}
          Exportar
        </Button>
        {canMutate && (
          <Button
            size="sm"
            variant="outline"
            disabled={!!busyAction}
            onClick={onDeleteBatch}
            data-testid="batch-delete-btn"
            className="bg-red-500/10 border-red-500/30 text-red-300 hover:bg-red-500/20"
          >
            {busyAction === "delete"
              ? <Loader2 size={14} className="mr-2 animate-spin" />
              : <Trash2 size={14} className="mr-2" />}
            Eliminar
          </Button>
        )}
        <Button
          size="sm"
          variant="ghost"
          onClick={onClear}
          data-testid="batch-clear-btn"
          className="text-slate-400 hover:text-white"
        >
          <X size={14} />
        </Button>
      </div>
      {batchProgress && (
        <div className="w-full text-xs text-slate-400 font-mono" data-testid="batch-progress">
          {batchProgress.label}
        </div>
      )}
    </div>
  );
}
